export function SwitchHorizontalIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g opacity="1">
        <path d="M13.3334 10.3333H2.66669L5.33335 13M2.66669 5.66667H13.3334L10.6667 3" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
      </g>
    </svg>
  );
}

SwitchHorizontalIcon.displayName = 'SwitchHorizontalIcon';
